<template>
    <nav class="max-w-7xl px-4 sm:px-6 lg:px-8 pt-6 pb-0 mx-auto">
        <div class="border-iron-200 flex items-center justify-between border-b">
            <div class="gap-1 -mb-px flex items-center">
                <Link
                    v-for="item in navItems"
                    :key="item.route"
                    :href="route(item.route)"
                    :class="[
                        'group gap-2 px-3 py-2.5 font-medium -mb-px flex items-center border-b-2 text-[13px] transition-colors',
                        isActive(item.route)
                            ? 'border-iron-900 text-iron-900'
                            : 'text-iron-400 hover:text-iron-600 hover:border-iron-300 border-transparent',
                    ]"
                >
                    <component
                        :is="item.icon"
                        :class="[
                            'h-3.5 w-3.5 transition-colors',
                            isActive(item.route)
                                ? 'text-iron-700'
                                : 'text-iron-300 group-hover:text-iron-500',
                        ]"
                    />
                    {{ item.label }}
                </Link>
            </div>

            <div class="sm:flex gap-1.5 pb-2 hidden items-center">
                <div class="h-1.5 w-1.5 bg-emerald-400 rounded-full"></div>
                <span
                    class="font-medium tracking-wide text-iron-400 text-[11px] uppercase"
                    >Kiosk</span
                >
            </div>
        </div>
    </nav>
</template>

<script setup lang="ts">
import { Link } from "@inertiajs/vue3";
import {
    LayoutDashboard,
    Users,
    CalendarCheck,
    BarChart3,
    ScrollText,
    Wrench,
} from "lucide-vue-next";

const navItems = [
    {
        route: "app.kiosk.dashboard.index",
        label: "Dashboard",
        icon: LayoutDashboard,
    },
    {
        route: "app.kiosk.users.index",
        label: "Users",
        icon: Users,
    },
    {
        route: "app.kiosk.reservations.index",
        label: "Reservations",
        icon: CalendarCheck,
    },
    {
        route: "app.kiosk.metrics.index",
        label: "Metrics",
        icon: BarChart3,
    },
    {
        route: "app.kiosk.api-logs.index",
        label: "API Logs",
        icon: ScrollText,
    },
    {
        route: "app.kiosk.tools.index",
        label: "Tools",
        icon: Wrench,
    },
];

function isActive(routeName: string): boolean {
    if (routeName === "app.kiosk.users.index") {
        return route().current("app.kiosk.users.*") ?? false;
    }
    return route().current(routeName) ?? false;
}
</script>
